import { Link } from 'gatsby'
import React, { useRef } from 'react'
import { useLink } from '../../hooks/useLink'
import { useParallaxCalculation } from '../../hooks/useParallax'

import { motion } from 'framer-motion'
import { useWindowSize } from 'react-use'

const M05TeaserHomeAlternate = ({
  heading,
  copy,
  image,
  youtubeId,
  video,
  videoMobile,
  roundImages,
  svgImageContent,
  svgImageContentMobile,
  teaserLink,
  variant,
  anchorLinkId,
}) => {
  const { width: windowWidth } = useWindowSize(
    typeof window !== 'undefined' ? window.innerWidth : 640,
  )
  const isMobile = windowWidth < 768
  const { label, url } = useLink(teaserLink)
  const hasLink = teaserLink?.type
  const hasMobileVideo = videoMobile && videoMobile[0]

  const ref1 = useRef(null)
  const ref2 = useRef(null)
  const { yRef1, yRef2, recalculateParallax } = useParallaxCalculation({
    ref1,
    ref2,
  })

  return (
    <section id={anchorLinkId}>
      <div className="container flex items-center my-28 md:my-32">
        <div
          className={`${
            variant === 'imageRight' ? 'row-type-c1' : 'row-type-c2'
          }`}
        >
          {variant === 'imageLeft' && (
            <div className="col-1-type-c" ref={ref2}>
              {image[0] && (
                <motion.img
                  src={image[0]?.url}
                  style={{ y: yRef2 }}
                  alt={heading}
                  onLoad={recalculateParallax}
                  className={`w-full h-auto ${
                    roundImages ? 'rounded shadow-tpmp lg:shadow-dp' : ''
                  }`}
                />
              )}
              {video && video.length > 0 && (
                <>
                  {isMobile && hasMobileVideo ? (
                    <video
                      width="100%"
                      height="auto"
                      muted
                      playsInline
                      autoPlay="autoplay"
                      fetchpriority="high"
                    >
                      <source
                        src={
                          videoMobile.find(
                            ({ extension }) => extension === 'mp4',
                          )?.url
                        }
                        type='video/mp4; codecs="hvc1"'
                      />
                      <source
                        src={
                          videoMobile.find(
                            ({ extension }) => extension === 'webm',
                          )?.url
                        }
                        type="video/webm"
                      />
                    </video>
                  ) : (
                    <motion.video
                      width="100%"
                      height="auto"
                      muted
                      playsInline
                      autoPlay="autoplay"
                      loop
                      className={`absolute top-0 left-0 object-cover ${
                        roundImages ? 'rounded shadow-tpmp lg:shadow-dp' : ''
                      }`}
                    >
                      <source
                        src={
                          video.find(({ extension }) => extension === 'mp4')
                            ?.url
                        }
                        type='video/mp4; codecs="hvc1"'
                      />
                      <source
                        src={
                          video.find(({ extension }) => extension === 'webm')
                            ?.url
                        }
                        type="video/webm"
                      />
                    </motion.video>
                  )}
                </>
              )}
              {youtubeId && (
                <iframe
                  title=""
                  src={`https://www.youtube.com/embed/${youtubeId}?modestbranding=1&rel=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className={`w-full aspect-video ${
                    roundImages && 'rounded shadow-tpmp lg:shadow-dp'
                  }`}
                ></iframe>
              )}
              {svgImageContent && (
                <div
                  className="hidden w-full u-has-svg md:block"
                  dangerouslySetInnerHTML={{ __html: svgImageContent }}
                ></div>
              )}
              {svgImageContentMobile && (
                <div
                  className="w-full u-has-svg md:hidden"
                  dangerouslySetInnerHTML={{ __html: svgImageContentMobile }}
                ></div>
              )}
            </div>
          )}
          <motion.div
            style={{ y: yRef1 }}
            ref={ref1}
            className={`${
              variant === 'imageRight' ? 'col-1-type-c' : 'col-2-type-c'
            }`}
          >
            <h2 className="mb-4 u-h2 lg:mb-6 xl:mb-5">{heading}</h2>
            <div
              className="mb-5 u-p column-indent lg:mb-4 xl:mb-6 link-wrapper"
              dangerouslySetInnerHTML={{ __html: copy }}
            />
            {hasLink && (
              <div className="column-indent">
                {['http', 'https', 'mailto'].some(externalPrefix =>
                  url.startsWith(externalPrefix),
                ) ? (
                  <a href={url} className="u-btn" target="_blank">
                    {label}
                  </a>
                ) : (
                  <Link to={url} className="u-btn">
                    {label}
                  </Link>
                )}
              </div>
            )}
          </motion.div>
          {variant === 'imageRight' && (
            <div className="col-2-type-c" ref={ref2}>
              {image?.[0] && (
                <motion.img
                  src={image[0]?.url}
                  style={{ y: yRef2 }}
                  alt={heading}
                  onLoad={recalculateParallax}
                  className={`w-full h-auto ${
                    roundImages ? 'rounded shadow-tpmp lg:shadow-dp' : ''
                  }`}
                />
              )}
              {video && video.length > 0 && (
                <>
                  {isMobile && hasMobileVideo ? (
                    <video
                      width="100%"
                      height="auto"
                      muted
                      playsInline
                      autoPlay="autoplay"
                      fetchpriority="high"
                    >
                      <source
                        src={
                          videoMobile.find(
                            ({ extension }) => extension === 'mp4',
                          )?.url
                        }
                        type='video/mp4; codecs="hvc1"'
                      />
                      <source
                        src={
                          videoMobile.find(
                            ({ extension }) => extension === 'webm',
                          )?.url
                        }
                        type="video/webm"
                      />
                    </video>
                  ) : (
                    <motion.video
                      width="100%"
                      height="auto"
                      muted
                      playsInline
                      autoPlay="autoplay"
                      loop
                      className={`absolute top-0 left-0 object-cover ${
                        roundImages ? 'rounded shadow-tpmp lg:shadow-dp' : ''
                      }`}
                    >
                      <source
                        src={
                          video.find(({ extension }) => extension === 'mp4')
                            ?.url
                        }
                        type='video/mp4; codecs="hvc1"'
                      />
                      <source
                        src={
                          video.find(({ extension }) => extension === 'webm')
                            ?.url
                        }
                        type="video/webm"
                      />
                    </motion.video>
                  )}
                </>
              )}
              {youtubeId && (
                <iframe
                  title=""
                  src={`https://www.youtube.com/embed/${youtubeId}?modestbranding=1&rel=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className={`w-full aspect-video ${
                    roundImages && 'rounded shadow-tpmp lg:shadow-dp'
                  }`}
                ></iframe>
              )}
            </div>
          )}
        </div>
        {/* <div className="w-5/12 pr-16">
        <h2 className="mb-8 text-3xl font-bold leading-tight md:text-4xl">
          {heading}
        </h2>

        <div className="mb-4" dangerouslySetInnerHTML={{ __html: copy }} />

        <Link
          to={linkUrl}
          className="inline-block px-4 py-2 text-sm text-white bg-black"
        >
          {linkLabel}
        </Link>
      </div>
      <div className="w-7/12">
        <div className="w-full h-96 bg-slate-200" />
      </div> */}
      </div>
    </section>
  )
}

export default M05TeaserHomeAlternate
